import BannerAtendimentoService2 from '../services/banner.atendimento2.service';

export const bannerAtendimento2 = {
  namespaced: true,
  actions: {
    get({ commit }) {
      return BannerAtendimentoService2.get();
      // return BannerHomeService.get().then(
      //   resp => {
      //     return Promise.resolve(resp);
      //   },
      //   error => {
      //     return Promise.reject(error);
      //   }
      // );
    }
  },
  mutations: {
    }
};
